import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { formatApiErrorDetail } from "../lib/api";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { Logo } from "../components/Logo";
import { IMG_AUTH_BG } from "../lib/images";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await login(form.email, form.password);
      navigate("/dashboard");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[calc(100vh-80px)] grid grid-cols-1 lg:grid-cols-2" data-testid="login-page">
      <div className="hidden lg:block relative">
        <img src={IMG_AUTH_BG} alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-midnight-black/50" />
      </div>
      <div className="flex items-center justify-center px-6 py-16 bg-clean-white">
        <div className="w-full max-w-sm">
          <div className="bg-midnight-black rounded-xl px-4 py-3 inline-block mb-10">
            <Logo className="h-9" />
          </div>
          <h1 className="font-extrabold uppercase text-2xl tracking-tight mb-2">Log In</h1>
          <p className="text-midnight-black/60 font-medium mb-8 text-sm">Welcome back. Your next Stranger Session is waiting.</p>
          <form onSubmit={handleSubmit} className="space-y-4" data-testid="login-form">
            <Input data-testid="login-email-input" type="email" placeholder="Email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
            <Input data-testid="login-password-input" type="password" placeholder="Password" required value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} />
            <div className="text-right">
              <Link to="/forgot-password" data-testid="forgot-password-link" className="text-xs font-bold text-midnight-black/60 hover:text-stranger-orange">
                Forgot password?
              </Link>
            </div>
            {error && (
              <p className="text-sm font-bold text-red-600" data-testid="login-error">
                {error}
              </p>
            )}
            <Button type="submit" data-testid="login-submit-button" disabled={loading} className="w-full bg-stranger-orange hover:bg-orange-600 text-clean-white font-bold tracking-wide rounded-full py-6">
              {loading ? "Logging in..." : "LOG IN"}
            </Button>
          </form>
          <p className="text-sm font-medium text-midnight-black/60 mt-6">
            New here?{" "}
            <Link to="/signup" data-testid="go-to-signup-link" className="text-stranger-orange font-bold hover:underline">
              Create an account
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}
